// extracted by mini-css-extract-plugin
module.exports = {"rulesPage":"rules_rulesPage__2kBWH","title":"rules_title__3Y6kU","info":"rules_info__22EFz"};